import { render, staticRenderFns } from "./SelectedUserAddress.vue?vue&type=template&id=5a53df06&scoped=true"
import script from "./SelectedUserAddress.vue?vue&type=script&lang=js"
export * from "./SelectedUserAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a53df06",
  null
  
)

export default component.exports